import { mockState } from '@/api/mock-data'
import { USE_MOCK } from '@/config'

/**
 * Fallback-хелперы для UI. В реальном режиме имена/телефоны/компании должны
 * прийти вместе с объектом (через embed в `listOrders`/`getOrder`), а эти
 * функции выступают последним запасным вариантом. В production-режиме они
 * возвращают безопасные «—» / id, а не обращаются к пустому `mockState`,
 * иначе пользователь видит UUID вместо ФИО.
 */
export function profileName(id: string | null | undefined): string {
  if (!id) return '—'
  if (USE_MOCK) {
    return mockState.profiles.find((p) => p.id === id)?.full_name ?? id
  }
  return id
}

export function companyName(id: string | null | undefined): string {
  if (!id) return '—'
  if (USE_MOCK) {
    return mockState.companies.find((c) => c.id === id)?.name ?? id
  }
  return id
}

export function companyPhone(id: string | null | undefined): string | null {
  if (!id) return null
  if (USE_MOCK) {
    return mockState.companies.find((c) => c.id === id)?.phone ?? null
  }
  return null
}

/** Телефон пользователя (только mock-fallback). */
export function profilePhoneById(id: string | null | undefined): string | null {
  if (!id) return null
  if (!USE_MOCK) return null
  const p = mockState.profiles.find((x) => x.id === id)
  const phone = p?.phone?.trim()
  return phone ? phone : null
}

/** Компания пользователя (только mock-fallback). */
export function profileCompanyNameByUserId(id: string | null | undefined): string | null {
  if (!id) return null
  if (!USE_MOCK) return null
  const cid = mockState.profiles.find((x) => x.id === id)?.company_id
  if (!cid) return null
  return companyName(cid)
}
